import * as React from 'react';
import Stepper from '@mui/joy/Stepper';
import Step, {stepClasses} from '@mui/joy/Step';
import StepIndicator, {stepIndicatorClasses} from '@mui/joy/StepIndicator';
import Typography from '@mui/joy/Typography';
import ContactsRoundedIcon from '@mui/icons-material/ContactsRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Background from '../cargo.jpeg';
import {FormControl, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";


export default function IconStepper() {
    const [searchWord, setSearchWord] = useState('')
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const handleSearch = async () => {
        if (!searchWord) {
            setError("Введите трек-код!");
            return;
        }

        try {
            setResult(null)
            setError(null)
            const response = await axios.get("https://reliablecargo.uz/api/v1/track?search=" + searchWord, {});
            if (response.data.length) {
                setResult(response.data[0]);
            } else {
                setError("Информация не найдена!");
            }
        } catch (err) {
            setError("Информация не найдена!");
            console.error(err);
        }
    };

    useEffect(() => {
        if (!searchWord) {
            setError("")
        }
    }, [searchWord]);

    return (
        <div className={"cargo"} style={{
            backgroundImage: `url(${Background})`, height: "100vh",
            backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"
        }}>
            <div className={"change-lang"}>
                <Link to={"/ru"}>
                    Tilni rus tiliga o'zgartirish
                </Link>
            </div>
            <div className="dark-overlay">
                <div className={"search-track"}>
                    <h1>Yuk holatini tekshirish</h1>
                    <p>Yuk trek kodini kiriting</p>
                    <p className={"d-flex flex-column"} style={{width: "50%", margin: "40px auto 0px"}}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="outlined-adornment-password">{"Trek-kodni kiriting"}</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={'text'}
                                autoFocus
                                value={searchWord}
                                onChange={(e) => setSearchWord(e.target.value)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle search"
                                            edge="end"
                                        >
                                            <SearchIcon/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label={"Izlash"}
                            />
                        </FormControl>
                        <Button onClick={() => handleSearch()} variant="contained" className={"mt-3"}>Izlash</Button>
                    </p>
                    {result ? result.status == "1" ?
                        <Stepper
                            size="lg"
                            sx={{
                                width: '100%',
                                '--StepIndicator-size': '3rem',
                                '--Step-connectorInset': '0px',
                                [`& .${stepIndicatorClasses.root}`]: {
                                    borderWidth: 4,
                                },
                                [`& .${stepClasses.root}::after`]: {
                                    height: 4,
                                },
                                [`& .${stepClasses.completed}`]: {
                                    [`& .${stepIndicatorClasses.root}`]: {
                                        borderColor: 'primary.600',
                                        color: 'primary.600',
                                    },
                                    '&::after': {
                                        bgcolor: 'primary.600',
                                    },
                                },
                                [`& .${stepClasses.active}`]: {
                                    [`& .${stepIndicatorClasses.root}`]: {
                                        borderColor: 'currentColor',
                                    },
                                },
                                [`& .${stepClasses.disabled} *`]: {
                                    color: 'neutral.outlinedDisabledColor',
                                },
                            }}
                        >
                            <Step
                                orientation="vertical"
                                completed
                                indicator={
                                    <StepIndicator variant="outlined" color="primary">
                                        <LocalShippingRoundedIcon/>
                                    </StepIndicator>
                                }
                            />
                            <Step
                                orientation="vertical"
                                completed
                                indicator={
                                    <StepIndicator variant="outlined" color="primary">
                                        <ContactsRoundedIcon/>
                                    </StepIndicator>
                                }
                            >
                                <Typography
                                    sx={{
                                        textTransform: 'uppercase',
                                        fontWeight: 'lg',
                                        fontSize: '0.75rem',
                                        letterSpacing: '0.5px',
                                    }}
                                >
                                    Yuk partiyalar bo'yicha saralanmoqda
                                </Typography>
                            </Step>
                            <Step
                                orientation="vertical"
                                disabled
                                indicator={
                                    <StepIndicator variant="outlined" color="neutral">
                                        <CheckCircleRoundedIcon/>
                                    </StepIndicator>
                                }
                            />
                        </Stepper> :
                        <Stepper
                            size="lg"
                            sx={{
                                width: '100%',
                                '--StepIndicator-size': '3rem',
                                '--Step-connectorInset': '0px',
                                [`& .${stepIndicatorClasses.root}`]: {
                                    borderWidth: 4,
                                },
                                [`& .${stepClasses.root}::after`]: {
                                    height: 4,
                                },
                                [`& .${stepClasses.completed}`]: {
                                    [`& .${stepIndicatorClasses.root}`]: {
                                        borderColor: 'primary.600',
                                        color: 'primary.600',
                                    },
                                    '&::after': {
                                        bgcolor: 'primary.600',
                                    },
                                },
                                [`& .${stepClasses.active}`]: {
                                    [`& .${stepIndicatorClasses.root}`]: {
                                        borderColor: 'currentColor',
                                    },
                                },
                                [`& .${stepClasses.disabled} *`]: {
                                    color: 'neutral.outlinedDisabledColor',
                                },
                            }}
                        >
                            <Step
                                orientation="vertical"
                                completed
                                indicator={
                                    <StepIndicator variant="outlined" color="primary">
                                        <LocalShippingRoundedIcon/>
                                    </StepIndicator>
                                }
                            />
                            <Step
                                orientation="vertical"
                                completed
                                indicator={
                                    <StepIndicator variant="outlined" color="primary">
                                        <ContactsRoundedIcon/>
                                    </StepIndicator>
                                }
                            ></Step>
                            <Step
                                orientation="vertical"
                                completed
                                indicator={
                                    <StepIndicator variant="outlined" color="primary">
                                        <CheckCircleRoundedIcon/>
                                    </StepIndicator>
                                }
                            >
                                <Typography
                                    sx={{
                                        textTransform: 'uppercase',
                                        fontWeight: 'lg',
                                        fontSize: '0.75rem',
                                        letterSpacing: '0.5px',
                                    }}
                                >
                                    Yuk O‘zbekistonga yetib keldi
                                </Typography>
                            </Step>
                        </Stepper> : <h4 className={"mt-4 text-center"}>{error == null ? "" : error}</h4>}

                </div>
            </div>
        </div>
    );
}